import { CircularProgress, Typography, Box } from "@mui/material";

const Loading = ({ description, size = 40, color = "primary", ...rest }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
      role="status"
      aria-live="polite"
      aria-label={description || "Carregando..."}
    >
      <CircularProgress size={size} color={color} {...rest} />
      {description && (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default Loading;
